import { createRouter } from '@tanstack/react-router';

import { NotFoundPage } from '@/pages/not-found.page';
import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
  routeTree,
  notFoundMode: 'root',
  defaultNotFoundComponent: NotFoundPage,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
